import List from "./list/Contracts";
import Individual from "./individual/Contract";

export default { List, Individual };
